module.exports = __webpack_public_path__ + "assets/views/00_common/stacked_callout_bg.png";